import { render, staticRenderFns } from "./LikeTags.vue?vue&type=template&id=e80c559e&scoped=true&"
import script from "./LikeTags.vue?vue&type=script&lang=js&"
export * from "./LikeTags.vue?vue&type=script&lang=js&"
import style0 from "./LikeTags.vue?vue&type=style&index=0&id=e80c559e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e80c559e",
  null
  
)

export default component.exports